/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class WaitSpinnerService {
    /** @ngInject */
    constructor($log) {
        this.visible = false;
        $log.debug('Service \'WaitSpinnerService\' loaded');
    }

    /**
     * Tells whether the wait spinner is visible.
     * 
     * @return {Boolean} True if the wait spinner is visible.
     */
    isVisible() {
        return this.visible;
    }
}

export { WaitSpinnerService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/service/WaitSpinnerService.js